import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "featureId", "featureCategoryId", "onClick", "tooltip", "usageTracker", "usageTrackerAppLocationKey", "loading"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { useTracker } from '../../hooks/useTracker';
import { AIBaseLoadingIconButton } from './internal/AIBaseLoadingIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const AILoadingIconButton = _ref => {
  let {
      children,
      featureId,
      featureCategoryId,
      onClick,
      tooltip,
      usageTracker,
      usageTrackerAppLocationKey,
      loading
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    aiTracker
  } = useTracker(usageTracker, usageTrackerAppLocationKey);
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      if (aiTracker) {
        aiTracker.track('aiButtonInteraction', {
          type: 'icon - trigger',
          featureId,
          featureCategoryId
        });
      }
    }
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    title: tooltip,
    children: /*#__PURE__*/_jsx(AIBaseLoadingIconButton, Object.assign({}, props, {
      "data-test-id": props['data-test-id'] || 'ai-icon-button',
      onClick: handleClick,
      loading: loading,
      children: children
    }))
  });
};
AILoadingIconButton.displayName = 'AILoadingIconButton';
export default AILoadingIconButton;